import { render, staticRenderFns } from "./Invoices2.vue?vue&type=template&id=51469a51"
import script from "./Invoices2.vue?vue&type=script&lang=js"
export * from "./Invoices2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports